import React from 'react'
import P from 'ui/bend/typography/P'
import FormikCheckbox from 'ui/bend/blocks/FormElements/FormikCheckbox'
import { Flex } from '../../elements'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  display: flex !important;
  align-items: center !important;
  text-align: left !important;
  margin-bottom: ${(props) => props.mb || 0} !important;
  margin-top: ${(props) => props.mt || 0} !important;
`

const MarketingDislaimer = ({ mb, mt = '0px', consentName }) => {
  const disclaimer = { name: '', description: '' }
  switch (consentName) {
    case 'consent_marketing_email':
      disclaimer.name = 'consent_marketing_email'
      disclaimer.description =
        'I agree to receive marketing emails with exclusive drops, offers and information. I may opt out by clicking unsubscribe at the bottom of any email.'
      break
    case 'consent_promotion_email':
      disclaimer.name = 'consent_promotion_email'
      disclaimer.description =
        'I agree to receive emails with exclusive drops and offers.'
      break
    case 'consent_alowellness_email':
      disclaimer.name = 'consent_alowellness_email'
      disclaimer.description =
        'I agree to receive marketing emails with information, special offers and promotions about ALO Wellness Club.'
      break
    case 'verify_page_consent_marketing_email':
      disclaimer.name = 'verify_page_consent_marketing_email'
      disclaimer.description =
        'I agree to receive marketing emails with information, special offers and promotions about ALO Wellness Club. I may opt out by clicking unsubscribe at the bottom of any email.'
      break
    default:
      disclaimer.name = 'consent_marketing_email'
      disclaimer.description =
        'I agree to receive marketing emails with information, special offers and promotions about ALO Wellness Club. I may opt out by clicking unsubscribe at the bottom of any email.'
  }
  return (
    <Wrapper mb={mb} mt={mt}>
      <div>
        <FormikCheckbox label={null} name={disclaimer.name} />
      </div>
      <P>{disclaimer.description}</P>
    </Wrapper>
  )
}

export default MarketingDislaimer
